/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flavor_DeletedInputs */

const en_flavor_deleted = /** @type {(inputs: Flavor_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flavor deleted`)
};

const es_flavor_deleted = /** @type {(inputs: Flavor_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabor eliminado`)
};

/**
* | output |
* | --- |
* | "Flavor deleted" |
*
* @param {Flavor_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const flavor_deleted = /** @type {((inputs?: Flavor_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flavor_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flavor_deleted(inputs)
	return es_flavor_deleted(inputs)
});